import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  PaginationState,
  paginationAdapter,
} from '../reducers/pagination.reducer';

export const getPaginationState =
  createFeatureSelector<PaginationState>('paginations');
export const getIds = (state: PaginationState) => state.ids;

export const {
  selectIds: getPaginationIds,
  selectEntities: getPaginationEntities,
  selectAll: getAllPaginations,
  selectTotal: getTotalPaginations,
} = paginationAdapter.getSelectors(getPaginationState);

export const getPaginationById = (id: string) =>
  createSelector(getAllPaginations, (allItems) => {
    if (allItems) {
      return allItems.find((item) => {
        return item.id === id;
      });
    } else {
      return null;
    }
  });
